export interface ICoordinates {
  x: number;
  y: number;
  bottom: number;
  top: number;
}

export function getCoordinates(
  el: HTMLElement,
  event: any,
  wrapper: Element
): ICoordinates {
  const xPosition =
    event.clientX - wrapper.getBoundingClientRect().left - el.clientWidth / 2;
  const yPosition =
    event.clientY - wrapper.getBoundingClientRect().top - el.clientHeight / 2;

  return {
    x: xPosition,
    y: yPosition,
    bottom: event.target.getBoundingClientRect().bottom,
    top: event.target.getBoundingClientRect().top
  };
}
